import { render } from "./PrivacyPolicy.vue?vue&type=template&id=203dd5e5&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=203dd5e5&scoped=true&lang=scss"
import "./PrivacyPolicy.vue?vue&type=style&index=1&id=203dd5e5&lang=css"
script.render = render
script.__scopeId = "data-v-203dd5e5"

export default script